import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BadgeCheckIcon, XIcon } from 'lucide-react';
const buyers = [{
  name: 'Mateo G.',
  city: 'Buenos Aires'
}, {
  name: 'Sofía R.',
  city: 'Córdoba'
}, {
  name: 'Lucas F.',
  city: 'Rosario'
}, {
  name: 'Martina P.',
  city: 'La Plata'
}, {
  name: 'Benjamín S.',
  city: 'Mendoza'
}, {
  name: 'Valentina M.',
  city: 'Mar del Plata'
}, {
  name: 'Joaquín L.',
  city: 'San Miguel de Tucumán'
}, {
  name: 'Camila D.',
  city: 'Salta'
}, {
  name: 'Thiago A.',
  city: 'Santa Fe'
}, {
  name: 'Emma C.',
  city: 'Neuquén'
}, {
  name: 'Tomás V.',
  city: 'Quilmes'
}, {
  name: 'Julieta B.',
  city: 'San Juan'
}, {
  name: 'Bautista N.',
  city: 'Resistencia'
}, {
  name: 'Catalina O.',
  city: 'Bahía Blanca'
}, {
  name: 'Santiago H.',
  city: 'Posadas'
}, {
  name: 'Renata T.',
  city: 'Paraná'
}];
const minutesAgoOptions = [1, 2, 3, 4, 5, 7, 8, 11];
interface Notif {
  name: string;
  city: string;
  minutesAgo: number;
  key: number;
}
const randomBetween = (min: number, max: number) => Math.floor(Math.random() * (max - min + 1)) + min;
export function PurchaseNotification() {
  const [notif, setNotif] = useState<Notif | null>(null);
  const timeoutsRef = useRef<number[]>([]);
  useEffect(() => {
    let counter = 0;
    const clearAll = () => {
      timeoutsRef.current.forEach(t => clearTimeout(t));
      timeoutsRef.current = [];
    };
    const showOne = () => {
      const buyer = buyers[Math.floor(Math.random() * buyers.length)];
      const minutesAgo = minutesAgoOptions[Math.floor(Math.random() * minutesAgoOptions.length)];
      counter += 1;
      setNotif({
        ...buyer,
        minutesAgo,
        key: counter
      });
      // Keep visible ~5.5s, then hide
      const hideT = window.setTimeout(() => {
        setNotif(null);
        // Wait 40–60s before the next one
        const nextDelay = randomBetween(40000, 60000);
        const nextT = window.setTimeout(showOne, nextDelay);
        timeoutsRef.current.push(nextT);
      }, 5500);
      timeoutsRef.current.push(hideT);
    };
    // First popup after a short initial delay
    const initialT = window.setTimeout(showOne, 6000);
    timeoutsRef.current.push(initialT);
    return clearAll;
  }, []);
  return <div className="fixed bottom-24 left-3 sm:bottom-5 sm:left-5 z-30 pointer-events-none" data-id="element-233">
      <AnimatePresence mode="wait" data-id="element-234">
        {notif && <motion.div key={notif.key} initial={{
        opacity: 0,
        x: -40,
        y: 10
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        x: -40
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="pointer-events-auto flex items-center gap-3 bg-navy-800/95 backdrop-blur-md border border-navy-700 rounded-xl shadow-[0_10px_30px_rgba(0,0,0,0.5)] px-3 py-2.5 sm:px-4 sm:py-3 max-w-[280px] sm:max-w-xs" data-id="element-235">
            <div className="flex-shrink-0 w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-green-500/15 flex items-center justify-center" data-id="element-236">
              <BadgeCheckIcon className="w-5 h-5 sm:w-6 sm:h-6 text-green-500" data-id="element-237" />
            </div>

            <div className="min-w-0" data-id="element-238">
              <p className="text-xs sm:text-sm text-offwhite leading-tight" data-id="element-239">
                <strong className="font-bold" data-id="element-240">{notif.name}</strong> de{' '}
                <strong className="font-bold" data-id="element-241">{notif.city}</strong>
              </p>
              <p className="text-[11px] sm:text-xs text-text-secondary leading-tight" data-id="element-242">
                compró el{' '}
                <span className="text-gold-400 font-semibold" data-id="element-243">
                  Kit Dominio Total
                </span>
              </p>
              <p className="text-[10px] sm:text-[11px] text-text-secondary/70 mt-0.5 flex items-center gap-1" data-id="element-244">
                <span className="inline-block w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse" data-id="element-245" />
                Compra verificada · hace {notif.minutesAgo} min
              </p>
            </div>

            <button onClick={() => setNotif(null)} aria-label="Cerrar notificación" className="flex-shrink-0 text-text-secondary/50 hover:text-text-secondary transition-colors self-start" data-id="element-246">
              <XIcon className="w-3.5 h-3.5" data-id="element-247" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}